import { Network } from 'vis-network';
import React, { createRef } from "react";
import {flattenJson} from "../../utils/util"
import { HL7resourcesAll, nodeColors } from '../../consts';


const options = {
    autoResize: true,
    height: '600px',
    width: '100%',
    physics: false,
    nodes: {
      fixed: {
        y: false,
        x:false
      },
      widthConstraint: {
        maximum: 250
      }
    },
    edges: {
      smooth: false
    },
  };

export default class ReferenceQA extends React.Component {

    constructor(props) {
      super(props);
      this.state = {
          nodes: [],
          edges: [],
          resource: {},
          mainNode: "",
          colors: {},
          colorList: nodeColors
      }
      this.network = {};
      this.appRef = createRef();
    }

    componentDidMount = async () => {
      let res = flattenJson(this.props.resource)
      let valueDict = {};
      await this.setState({
        resource: res,
        mainNode: res.resourceType,
        nodes: [{ id: res.resourceType, label: res.resourceType, physics: false}]
      }, () => {})
      for (let [key, value] of Object.entries(this.state.resource)) {
        for (let i in HL7resourcesAll){
          let startStr = HL7resourcesAll[i] + '/';
          if ( String(value).startsWith(startStr) && key !== 'resourceType') {
            let nodes = this.state.nodes;
            let edges = this.state.edges;
            if (!this.containsObject(nodes, String(value))) {
              let node = {
                id: String(value),
                label: String(value),
                color: this.getColor(value),
                shape: 'box'
              }
              valueDict[value] = 1
              nodes.push(node)
            } else {
              valueDict[value] = valueDict[value] + 2;
            }

            edges.push({ from: this.state.mainNode,
                        to: String(value),
                        label: (('\n'.repeat(valueDict[value]))+ key),
                        length: ((key.length) * 25),
                        font: { align: "middle", size: 12 },
                        physics: true,
                        arrows:'to',
                        smooth: {type: "curvedCCW", roundness: 0.4}
                      });
            this.setState({
              nodes: nodes,
              edges: edges
            })
          }
        }
      }
      this.renderGraph()
    }

    getColor(currKey) {
      let colorsDict = this.state.colors
      for (let [key, value] of Object.entries(this.state.colors)) {
        if (currKey == key ) {
          return value;
        }
      }
      colorsDict[currKey] = this.state.colorList[0]
      let remainingColors = this.state.colorList.slice(1)
      this.setState({colors: colorsDict, colorList: remainingColors})

      return colorsDict[currKey]
    }

    containsObject(obj, value) {
      for (let i in obj) {
          if (obj[i].id === value) {
              return true;
          }
      }

      return false;
  }

    renderGraph(){
      this.network = new Network(
        this.appRef.current,
        {
          nodes: this.state.nodes,
          edges: this.state.edges
        },
        options
      );
    }

    render() {
      return (
        <div ref={this.appRef} />
      );
    }
  }

